export default "__VITE_ASSET__Df5ww96n__"